import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as ImportList from 'import/components/list';
import * as Common from 'common/components';

import { createRoute } from 'lib/util';
const { Form } = Common;

class ImportListView extends Component {
  static propTypes = {
    company: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
    subcompany: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    records: PropTypes.array.isRequired,
    permissions: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    handleToggle: PropTypes.func.isRequired,
    handleFiltersChange: PropTypes.func.isRequired,
    handleFiltersSubmit: PropTypes.func.isRequired,
    handleLimitChange: PropTypes.func.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    handleReImportCSV: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false };

  handleSubmit = ({ isValid }) =>
    this.setState({ isSubmitted: true }, () => this.props.handleSubmit({ isValid }));

  handleValidation = (errors) => this.setState({ isValid: Object.keys(errors).length === 0 });

  render = () => {
    return (
      <Common.Wrapper fluid={true}>
        {/* <ImportList.Header
          canAdd={this.props.permissions["acl.import.import"]}
          companyId={this.props.company.id}
          subcompanyId={this.props.subcompany.id}
        /> */}
        <div className="col-12">
          <Common.Portlet
            title={this.props.t('import.list_subtitle')}
            icon={'upload'}
            button={
              <div className="btn-group pull-right">
                {this.props.permissions['acl.import.import'] && (
                  <Form.Link
                    to={createRoute(this.props.company.id, this.props.subcompany.id, 'import/add')}
                    className="btn btn-info"
                  >
                    {this.props.t('actions.add')}
                  </Form.Link>
                )}
              </div>
            }
          >
            <div className="mb-2" style={{ position: 'relative' }}>
              <ImportList.Table
                company={this.props.company}
                subcompany={this.props.subcompany}
                permissions={this.props.permissions}
                handleToggle={this.props.handleToggle}
                count={this.props.records.length}
                handleOrderChange={this.props.handleOrderChange}
                handleReImportCSV={this.props.handleReImportCSV}
                isLoading={this.props.isLoading}
                order={this.props.pagination.order}
                orderBy={this.props.pagination.orderBy}
              >
                {this.props.children}
              </ImportList.Table>
              <Common.LoaderOverlay show={this.props.isLoading} />
            </div>

            <ImportList.Modal
              modulo={this.props.modulo}
              handleAccept={this.props.handleAccept}
              handleSelectHeaders={this.props.handleSelectHeaders}
              handleClose={this.props.handleClose}
              isOpened={this.props.isOpened}
            />
            <Common.Pagination
              {...this.props.pagination}
              handleLimitChange={this.props.handleLimitChange}
              handlePageChange={this.props.handlePageChange}
            />
          </Common.Portlet>
        </div>
      </Common.Wrapper>
    );
  };
}

export default translate()(ImportListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/ImportListView.js